module.exports = __webpack_public_path__ + "img/home-logo.f7b60baf.png";